export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/fbf1cfaf74329f9a6a1fed67972e7c52.svg";